import { render } from "./ConfusionMatrixV2.vue?vue&type=template&id=5af0671d"
import script from "./ConfusionMatrixV2.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixV2.vue?vue&type=script&lang=js"

import "./ConfusionMatrixV2.vue?vue&type=style&index=0&id=5af0671d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__